import React from 'react';
import { CardComponent } from '../CardComponent';


export function DynamicAge(props) {
  const {isLoading, handleInputCounter, dynamicAge, setDynamicAgeModal, saveDynamicAge, bankName} = props;
  const title= `Modify Dynamic Age - Days for ${bankName}`; 
  return (
    <CardComponent
    title={title}
    titleStyles={{display:'inline-block', fontSize:'2.6rem', fontWeight: 400, marginLeft: '30px', marginTop:'20px'}}
    styles={{position:'fixed', top: '20%', left: '20%', zIndex: 1050, background:'white', minHeight: '270px', width:'570px', border:'solid grey', borderRadius: '10px'}}
    isLoading={isLoading}
    disableCardBackgroundColor
    >
      <div style={{alignContent: 'center', marginLeft: '20px', marginRight:'20px'}}>
        <div>
          <small><i style={{color: 'blue !important'}}>All fields are required.</i></small>
          <div className="row blacklight" style={{padding: '5px', marginBottom: '5px'}}>
            <div className="col s12 blacklight">
              <label>
                Dynamic Age - Days
              </label>
              <input 
                type="number" 
                onChange={handleInputCounter}
                value={dynamicAge}
              />
            </div>
            <a className="btn btn-white blacklight"
              onClick={()=>{setDynamicAgeModal(false)}}
              style={{marginTop:'20px', marginLeft:'5px', marginRight:'20px', textAlign: 'center', cursor: 'pointer', float:'right', color: 'rgba(0,0,0,0.87)', backgroundColor: 'transparent', border:'none', fontSize:'16px', width: '100px'}}
            >
              CLOSE
            </a>
            <a className="btn btn-white"
              onClick={()=>{saveDynamicAge()}}
              style={{marginTop:'20px', textAlign: 'center', cursor: 'pointer', float:'right', color: 'rgba(0,0,0,0.87)', backgroundColor: 'transparent', border:'none', fontSize:'16px', width: '100px'}}
            >
              SAVE
            </a>
          </div>
        </div>
      </div>
    </CardComponent>
  );
}
